import { Link, useLocation } from 'react-router-dom';
import ObfuscatedContact from '@/components/base/ObfuscatedContact';

export default function Footer() {
  const location = useLocation();
  const isFrench = location.pathname.startsWith('/fr');

  const quickLinks = isFrench
    ? [
        { label: 'Accueil', path: '/fr' },
        { label: 'Services', path: '/fr/services' },
        { label: 'Produits', path: '/fr/produits' },
        { label: 'Fournisseurs', path: '/fr/fournisseurs' },
        { label: 'Contact', path: '/fr/contact' },
      ]
    : [
        { label: 'Home', path: '/' },
        { label: 'Services', path: '/services' },
        { label: 'Products', path: '/products' },
        { label: 'Suppliers', path: '/suppliers' },
        { label: 'Contact', path: '/contact' },
      ];

  const services = isFrench
    ? ['Approvisionnement stratégique', 'Conformité réglementaire', 'Liaison exécutive', 'Logistique & Contrats']
    : ['Strategic Sourcing', 'Regulatory Compliance', 'Executive Liaison', 'Logistics & Contracts'];

  return (
    <footer className="bg-stone-100 border-t border-stone-200">
      {/* Top grid */}
      <div className="w-full px-6 md:px-16 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        {/* Brand */}
        <div>
          <img
            src="https://storage.readdy-site.link/project_files/f6608a11-bffc-43fe-b4fe-e188634774f2/410f07b3-9a07-4d96-ad6c-8cd90865ebc1_maxsourc3mugs.jpg?v=01df200e03a67f06d87190a3955ab7c3"
            alt="MAX Sourcing"
            className="h-16 w-auto object-contain mb-4"
          />
          <p className="text-sm text-gray-500 leading-relaxed">
            {isFrench ? 'Nous livrons en matière d\'approvisionnement.' : 'We deliver on Sourcing.'}
          </p>
          <div className="mt-4 flex items-center gap-2">
            <div className="flex items-center gap-1 bg-emerald-50 border border-emerald-200 rounded-full px-3 py-1">
              <i className="ri-translate-2 text-emerald-600 text-sm" />
              <span className="text-xs font-bold text-emerald-700 tracking-widest">FR · EN</span>
            </div>
            <span className="text-xs text-gray-400">{isFrench ? 'Service bilingue' : 'Bilingual Service'}</span>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-gray-800 mb-4">
            {isFrench ? 'Liens rapides' : 'Quick Links'}
          </h4>
          <div className="w-8 h-0.5 bg-emerald-600 mb-4" />
          <ul className="flex flex-col gap-2">
            {quickLinks.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="text-sm text-gray-500 hover:text-emerald-700 transition-colors cursor-pointer">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services */}
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-gray-800 mb-4">Services</h4>
          <div className="w-8 h-0.5 bg-emerald-600 mb-4" />
          <ul className="flex flex-col gap-2">
            {services.map((s) => (
              <li key={s}>
                <span className="text-sm text-gray-500">{s}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-gray-800 mb-4">Contact</h4>
          <div className="w-8 h-0.5 bg-emerald-600 mb-4" />
          <ul className="flex flex-col gap-3 text-sm text-gray-500">
            <li className="flex items-start gap-2">
              <i className="ri-map-pin-line text-emerald-600 mt-0.5" />
              <span>{isFrench ? 'Amérique du Nord — Europe — Chine — Inde' : 'North America — Europe — China — India'}</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-emerald-600" />
              <ObfuscatedContact
                type="email"
                className="hover:text-emerald-700 transition-colors cursor-pointer break-all text-sm text-gray-500"
              />
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-phone-line text-emerald-600" />
              <ObfuscatedContact
                type="phone"
                className="hover:text-emerald-700 transition-colors cursor-pointer text-sm text-gray-500"
              />
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="bg-stone-800 px-6 md:px-16 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-stone-400">
          © Copyright 2009–2026 MAX-Sourcing. * Is a Trademark. All rights reserved. &nbsp;
          <Link
            to={isFrench ? '/fr/conditions' : '/terms'}
            className="hover:text-stone-200 transition-colors cursor-pointer"
          >
            {isFrench ? 'Conditions d\'utilisation' : 'Terms of Use'}
          </Link>
          &nbsp;&amp;&nbsp;
          <Link
            to={isFrench ? '/fr/conditions' : '/terms'}
            className="hover:text-stone-200 transition-colors cursor-pointer"
          >
            {isFrench ? 'Confidentialité' : 'Privacy Policy'}
          </Link>
        </p>
      </div>
    </footer>
  );
}
